var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kw-flatpicker__group"},[_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"kw-flatpicker__clear",class:{ _visible: _vm.showClearBtn },attrs:{"data-clear":""}},[_c('kw-svgicon',{attrs:{"name":"remove"}})],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c35d1d1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UI/KwFlatpickerWrapper.vue
// module id = null
// module chunks = 